import { protectedResources } from '@/authConfig';
import { makePostRequestAsync } from '@/http/Helpers/httpRequestHelpers';

import {
  SwitchToCompanyRequest,
  SwitchToCompanyResponse
} from '../types/CompanySwitch.types';

const baseUrl = protectedResources.userManagementWebApi.endpoint;
const apiScopes = protectedResources.userManagementWebApi.scopes;

/**
 * Switch to a different company
 */
export const switchToCompany = async (
  request: SwitchToCompanyRequest
): Promise<SwitchToCompanyResponse> => {
  const url = `${baseUrl}/api/UserManagement/CompanySwitching`;
  const response = await makePostRequestAsync<void, SwitchToCompanyRequest>(
    apiScopes,
    url,
    request
  );
  return { success: response.status === 200 };
};
